import * as React from 'react';

interface Props {
	className?: string;
	card: StripeCard;
}
const CardDetails: React.StatelessComponent<Props> = props => {
	return (
		<div className={props.className}>
			<div><strong>{props.card.brand} ending in {props.card.last4}</strong></div>
			<div>Expires: {props.card.expirationMonth}/{props.card.expirationYear}</div>
			<div>Cardholder's name: {props.card.name}</div>
		</div>
	);
};

export default CardDetails;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/payment/CardDetails.tsx